import { motion } from 'framer-motion';
import { Droplets, Waves } from 'lucide-react';
import { Card, CardBody } from '@/components/ui/Card';

interface Props { flowRate?: number; totalLitres?: number }

export function FlowGauge({ flowRate, totalLitres }: Props) {
  const rate = Number.isFinite(flowRate) ? (flowRate as number) : 0;
  const total = Number.isFinite(totalLitres) ? (totalLitres as number) : 0;
  const active = rate > 0;

  return (
    <Card>
      <CardBody className="grid grid-cols-2 gap-4">
        <div>
          <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">
            <Waves className="w-3.5 h-3.5" />
            Flow
          </div>
          <motion.div
            key={rate}
            initial={{ opacity: 0.6 }}
            animate={{ opacity: 1 }}
            className="text-3xl font-extrabold tabular-nums text-ink mt-1"
          >
            {rate.toFixed(2)}
            <span className="text-sm font-medium text-slate-400 ml-1">L/min</span>
          </motion.div>
          {active && <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase text-emerald-600 mt-1">
            <span className="w-1.5 h-1.5 rounded-full bg-ok heartbeat" />
            flowing
          </span>}
        </div>
        <div>
          <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">
            <Droplets className="w-3.5 h-3.5" />
            Session total
          </div>
          <div className="text-3xl font-extrabold tabular-nums text-ink mt-1">
            {total.toFixed(3)}
            <span className="text-sm font-medium text-slate-400 ml-1">L</span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
